<div class="container">
  <div class="main">
    <div class="header">
      <div class="icon"><mat-icon>donut_large</mat-icon></div>
      <h2 class="title">AI Sales Coach</h2>
    </div>
    <div class="content">
      @if (!hasSent) {
        <div class="navigation">
          <button class="back-button" (click)="backToLogin()">
            <mat-icon>keyboard_arrow_left</mat-icon>
          </button>
        </div>
        <h3 class="title">パスワードの再設定</h3>
        <p class="message">
          @if (message) {
            {{ message }}
          }
          @if (!message) {
            登録されたメールアドレスを入力してください。
            パスワードを設定するためのリンクを送信いたします。
          }
        </p>
        <form
          [formGroup]="resetPasswordForm"
          (submit)="sendPasswordResetEmailSubmit($event)"
        >
          <div class="inputs">
            <div class="input-wrapper">
              <input
                id="email"
                name="email"
                class="email"
                placeholder="メールアドレス"
                autocomplete="email"
                formControlName="email"
                required
              />
            </div>
          </div>
          <div class="button-wrapper">
            <button
              type="submit"
              rectangle
              class="primary"
              [disabled]="resetPasswordForm.invalid"
            >
              送信
            </button>
          </div>
        </form>
      }
      @if (hasSent) {
        <p class="description">
          パスワードを再設定するためのリンクが記載されたメールを送信しました。
          受信メールをご確認ください。
        </p>
        <div class="button-wrapper">
          <button rectangle class="primary" (click)="backToLogin()">
            ログイン画面に戻る
          </button>
        </div>
      }
    </div>
  </div>
</div>
